import DbService from 'resources/db.service';
import schema from './audit.schema';
import { AUDIT_STATUSES, AUDIT_TYPES } from './audit.constants';

const service = new DbService('audits', { schema });


const createAudit = async ({
  id,
  companyId,
  name,
  type,
  listedkitId,
  dealId,
  dueInDays,
  isAfterAction,
  dueRelativeDate,
}) => {
  const { data } = await service.create({
    ...(id && { id }),
    company_id: companyId,
    name,
    type,
    ...(listedkitId && { listedkit_id: listedkitId }),
    ...(dealId && { deal_id: dealId }),
    status: AUDIT_STATUSES.NOT_STARTED,
    due_in_days: dueInDays,
    is_after_action: !!isAfterAction,
    due_relative_date: dueRelativeDate,
  });

  return data[0];
};

const updateAudit = async (data) => {
  const response = await service.updateOne({ id: data.id }, data);

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const removeAudit = async (id) => {
  const response = await service.remove({ id });

  if (response.isBadRequest) {
    return null;
  }

  return response.data[0];
};

const removeKitAudits = async (kitId) => {
  const response = await service.remove({ listedkit_id: kitId });

  if (response.isBadRequest) {
    return null;
  }

  return response.data;
};

const getKitAudits = async (listedkitId) => {
  const data = await service.find({
    listedkit_id: listedkitId,
  });

  return data;
};

const getDealAudits = async (dealId) => {
  const data = await service.find({
    deal_id: dealId,
  });

  return data;
};

const getAuditsByDealIds = async (dealIds) => {
  // let response = await service.select().in('deal_id', dealIds);

  let response = await service.selectByKey({
    selectKey: 'getAuditsByDealIds',
    params: { dealIds },
  });

  response = service.processResponse(response);
  
  return response.data.length > 0 ? response.data : null;
};

const getUnderContractAuditsByDealId = async (dealId) => {
  const data = await service.find({
    deal_id: dealId,
    type: AUDIT_TYPES.UNDER_CONTRACT,
  });

  return data;
};

const getPreContractAuditsByDealId = async (dealId) => {
  const data = await service.find({
    deal_id: dealId,
    type: AUDIT_TYPES.PRE_CONTRACT,
  });

  return data;
};

const getAllKitsAudits = async (companyId) => {
  // const response = await service
  //   .select()
  //   .eq('company_id', companyId)
  //   .is('deal_id', null)
  //   .not('listedkit_id', 'is', null);

  let response = await service.selectByKey({
    selectKey: 'getAllKitsAudits',
  });

  response = service.processResponse(response);
  
  return response?.data;
};

export default Object.assign(service, {
  createAudit,
  updateAudit,
  removeAudit,
  removeKitAudits,
  getKitAudits,
  getDealAudits,
  getPreContractAuditsByDealId,
  getUnderContractAuditsByDealId,
  getAuditsByDealIds,
  getAllKitsAudits,
});
